import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { ICON_NAMES } from 'components/Icon';

class SocialLinks extends Component {
  render() {
    const { color, addId, socials } = this.props;
    const white = color === "white" ? "icon--white" : "";
    const whiteLink = color === "white" ? "social-links__link-white" : "";

    return !socials ? null : (
      <div className="social-links">
        <ul className="social-links__list">
          {socials.facebook && (
            <li className="social-links__item">
              <a
                target='_blank'
                rel="noopener noreferrer"
                href={socials.facebook}
                className={`social-links__link social-links__link-facebook ${whiteLink}`}
              >
                <Icon name={ICON_NAMES.facebook} className={`icon--facebook ${white}`} />
              </a>
            </li>
          )}

          {socials.twitter && (
            <li className="social-links__item">
              <a
                target='_blank'
                rel="noopener noreferrer"
                href={socials.twitter}
                className={`social-links__link social-links__link-twitter ${whiteLink}`}
              >
                <Icon name={ICON_NAMES.twitter} className={`icon--twitter ${white}`} />
              </a>
            </li>
          )}

          {socials.youtube && (
            <li className="social-links__item">
              <a
                target='_blank'
                rel="noopener noreferrer"
                href={socials.youtube}
                className={`social-links__link social-links__link-youtube ${whiteLink}`}
              >
                <Icon name={ICON_NAMES.youtube} className={`icon--youtube ${white}`} />
              </a>
            </li>
          )}

          {socials.linkedin && (
            <li className="social-links__item">
              <a
                target='_blank'
                rel="noopener noreferrer"
                href={socials.linkedin}
                className={`social-links__link social-links__link-linkedin ${whiteLink}`}
              >
                <Icon name={ICON_NAMES.linkedin} className={`icon--linkedin ${white}`} />
              </a>
            </li>
          )}

          {socials.instagram && (
            <li className="social-links__item">
              <a
                target='_blank'
                rel="noopener noreferrer"
                href={socials.instagram}
                className={`social-links__link social-links__link-instagram ${whiteLink}`}
              >
                <Icon name={ICON_NAMES.instagram} className={`icon--instagram ${white}`} active={addId} />
              </a>
            </li>
          )}
        </ul>
      </div>
    )
  }
}

SocialLinks.propTypes = {
  color: PropTypes.oneOf(['default', 'white']),
};

SocialLinks.defaultProps = {
  color: 'default'
};

export default SocialLinks;